import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./SpecialCircumstances.module.css";

/**
 * Interactive component. Displays special circumstances with the ability to edit and save changes.
 */
export function SpecialCircumstances({ specialCircumstances, onSave }) {
  const [isEdit, setIsEdit] = useState(false);
  const [tempCircumstances, setTempCircumstances] =
    useState(specialCircumstances);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>Special Circumstances</p>
        <div className={styles.grid}>
          <button
            className={classNames(styles.transition, styles["button"], {
              [styles.hidden]: isEdit,
            })}
            onClick={() => setIsEdit(true)}
          >
            Edit
          </button>
          <button
            className={classNames(styles.transition, styles["button"], {
              [styles.hidden]: !isEdit,
            })}
            onClick={() => {
              setIsEdit(false);
              onSave(tempCircumstances);
            }}
          >
            Save
          </button>
        </div>
      </div>
      <div
        className={classNames(styles.transition, styles.textarea, {
          [styles.hidden]: !isEdit && !specialCircumstances,
        })}
      >
        <label htmlFor="special-circumstances" hidden>
          Special Circumstances
        </label>
        <textarea
          name="special-circumstances"
          placeholder="Add text here..."
          disabled={!isEdit}
          onChange={(key) => setTempCircumstances(key.target.value)}
        />
      </div>
    </div>
  );
}

SpecialCircumstances.propTypes = {
  /**
   * String (optional) that displays special circumstances (if needed)
   */
  specialCircumstances: PropTypes.string,
  /**
   * Function called when save is clicked.
   */
  onSave: PropTypes.func,
};
